(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["airl-feature"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(root) {
    var items = root.querySelectorAll('.arf-reveal');
    function showAll() { items.forEach(function (el) { el.classList.add('is-in'); }); }
    if (!('IntersectionObserver' in window)) { showAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    items.forEach(function (el) { io.observe(el); });
    setTimeout(showAll, 2500);
  }

  function typer(root) {
    var out = root.querySelector('[data-arf-type]');
    var src = root.querySelector('[data-arf-prompts]');
    if (!out || !src || root.__arfTyping) return;
    var words = [].map.call(src.querySelectorAll('li'), function (li) { return li.textContent.trim(); }).filter(Boolean);
    if (!words.length) return;
    var animOn = root.getAttribute('data-arf-anim') !== 'false';
    if (!animOn) { out.textContent = words[0]; return; }
    root.__arfTyping = true;
    var wi = 0, ci = 0, deleting = false;
    function tick() {
      var word = words[wi];
      if (!deleting) {
        ci++;
        out.textContent = word.slice(0, ci);
        if (ci >= word.length) { deleting = true; return setTimeout(tick, 1400); }
        setTimeout(tick, 60 + Math.random() * 50);
      } else {
        ci--;
        out.textContent = word.slice(0, ci);
        if (ci <= 0) { deleting = false; wi = (wi + 1) % words.length; return setTimeout(tick, 300); }
        setTimeout(tick, 30);
      }
    }
    tick();
  }

  function tilt(root) {
    if (root.getAttribute('data-arf-anim') === 'false') return;
    if (!(window.matchMedia && window.matchMedia('(pointer: fine)').matches)) return;
    var fr = root.querySelector('[data-arf-tilt]');
    if (!fr || fr.__arfTilt) return;
    fr.__arfTilt = true;
    var raf = null;
    fr.addEventListener('mousemove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        var r = fr.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        fr.style.transform = 'perspective(900px) rotateY(' + (x * 9).toFixed(2) + 'deg) rotateX(' + (-y * 9).toFixed(2) + 'deg) scale(1.02)';
        raf = null;
      });
    });
    fr.addEventListener('mouseleave', function () {
      fr.style.transform = '';
    });
  }

  function init() {
    document.querySelectorAll('[data-arf]').forEach(function (root) {
      reveal(root);
      typer(root);
      tilt(root);
    });
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airl-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStage(stage) {
    if (!stage || stage.dataset.airlReady === 'true') return;
    stage.dataset.airlReady = 'true';
    var video = stage.querySelector('[data-airl-video]');
    if (!video) return;

    // Play only while in view (perf + battery).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.15 });
      io.observe(stage);
    }
  }

  function initAll(ctx) {
    (ctx || document).querySelectorAll('[data-airl-stage]').forEach(initStage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-splinter"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fallbackFormat(cents, fmt) {
    var amount = cents / 100;
    var value;
    if (fmt && /amount_no_decimals/.test(fmt)) {
      value = Math.round(amount).toString();
    } else if (fmt && /with_comma_separator/.test(fmt)) {
      value = amount.toFixed(2).replace('.', ',');
    } else {
      value = amount.toFixed(2);
    }
    var brace = '{' + '{';
    if (fmt && fmt.indexOf(brace) !== -1) {
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, value);
    }
    return (fmt || '') + value;
  }

  function money(cents, fmt) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    if (window.theme && theme.Currency && fmt) {
      return theme.Currency.formatMoney(cents, fmt);
    }
    return fallbackFormat(cents, fmt);
  }

  function cartType() {
    if (window.theme && theme.settings && theme.settings.cartType) return theme.settings.cartType;
    return 'page';
  }

  function initSplinter(root) {
    if (!root || root.dataset.splinterReady === 'true') return;
    root.dataset.splinterReady = 'true';

    var scope = root.closest('[data-splinter-scope]') || root.parentNode;
    if (scope && scope.classList) scope.classList.add('spl-has-js');
    root.classList.add('spl-has-js');

    var variantsScript = scope.querySelector('[data-splinter-variants]');
    var variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }

    var form = root.querySelector('[data-splinter-form]');
    var idInput = root.querySelector('[data-splinter-variant-id]');
    var priceEl = root.querySelector('[data-splinter-price]');
    var compareEl = root.querySelector('[data-splinter-compare]');
    var saleTag = root.querySelector('[data-splinter-sale-tag]');
    var addBtn = root.querySelector('[data-splinter-add]');
    var addText = addBtn ? addBtn.querySelector('[data-splinter-add-text]') : null;
    var errorEl = root.querySelector('[data-splinter-error]');
    var qtyInput = root.querySelector('[data-splinter-qty]');
    var moneyFormat = root.getAttribute('data-money-format');
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var stickyPrice = root.querySelector('[data-splinter-sticky-price]');
    var stickyBtn = root.querySelector('[data-splinter-sticky-add]');
    var stickyText = stickyBtn ? stickyBtn.querySelector('[data-splinter-sticky-text]') : null;

    var current = null;

    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('.spl-option'));
    var selected = [];
    optionGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var sel = group.querySelector('.spl-swatch.is-selected');
      selected[idx] = sel ? sel.getAttribute('data-option-value') : null;
    });

    function findVariant() {
      if (!optionGroups.length) return variants[0];
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return String(opt) === String(selected[i]); });
      });
    }

    function anyAvailableForValue(optionIndex, value) {
      return variants.some(function (v) {
        if (String(v.options[optionIndex]) !== String(value)) return false;
        return v.available;
      });
    }

    function refreshSoldOut() {
      optionGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('.spl-swatch').forEach(function (btn) {
          var val = btn.getAttribute('data-option-value');
          btn.classList.toggle('is-soldout', !anyAvailableForValue(idx, val));
        });
      });
    }

    function setBuyState(available) {
      var defTxt = addBtn ? addBtn.getAttribute('data-add-default') : 'Add to cart';
      var outTxt = addBtn ? addBtn.getAttribute('data-add-soldout') : 'Sold out';
      if (addBtn) addBtn.disabled = !available;
      if (addText) addText.textContent = available ? defTxt : outTxt;
      if (stickyBtn) stickyBtn.disabled = !available;
      if (stickyText) stickyText.textContent = available ? defTxt : outTxt;
    }

    function updateUI() {
      var variant = findVariant();
      current = variant || null;

      if (!variant) {
        setBuyState(false);
        return;
      }

      if (idInput) idInput.value = variant.id;

      var priceStr = money(variant.price, moneyFormat);
      if (priceEl) priceEl.textContent = priceStr;
      if (stickyPrice) stickyPrice.textContent = priceStr;

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        if (onSale) {
          compareEl.textContent = money(variant.compare_at_price, moneyFormat);
          compareEl.classList.remove('hide');
        } else {
          compareEl.classList.add('hide');
        }
      }
      if (saleTag) saleTag.classList.toggle('hide', !onSale);

      setBuyState(variant.available);
    }

    optionGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var label = group.querySelector('[data-option-selected-label="' + idx + '"]');
      group.querySelectorAll('.spl-swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selected[idx] = btn.getAttribute('data-option-value');
          group.querySelectorAll('.spl-swatch').forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-checked', 'true');
          if (label) label.textContent = btn.getAttribute('data-option-value');
          updateUI();
        });
      });
    });

    // Quantity stepper
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (minus && qtyInput) minus.addEventListener('click', function () {
      var n = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, n - 1);
    });
    if (plus && qtyInput) plus.addEventListener('click', function () {
      var n = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = n + 1;
    });

    // Gallery — glitch transitions, arrows, swipe, counter
    var stage = root.querySelector('[data-splinter-stage]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.spl-thumb'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('.spl-stage__slide'));
    var countEl = root.querySelector('[data-stage-count]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var curSlide = 0;
    var glitchTimer = null;

    function pad2(n) { return (n < 10 ? '0' : '') + n; }

    function setSlide(index, glitch) {
      if (!slides.length) { return; }
      if (index < 0) { index = slides.length - 1; }
      if (index >= slides.length) { index = 0; }
      curSlide = index;
      var target = String(index);
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-stage-slide') === target); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-stage-target') === target); });
      if (countEl) { countEl.textContent = pad2(index + 1) + ' / ' + pad2(slides.length); }
      if (glitch && stage && !reduceMotion) {
        stage.classList.remove('is-glitching');
        void stage.offsetWidth; // force reflow so the animation restarts
        stage.classList.add('is-glitching');
        if (glitchTimer) { clearTimeout(glitchTimer); }
        glitchTimer = setTimeout(function () { stage.classList.remove('is-glitching'); }, 460);
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setSlide(parseInt(thumb.getAttribute('data-stage-target'), 10) || 0, true);
      });
    });
    var prevBtn = root.querySelector('[data-stage-prev]');
    var nextBtn = root.querySelector('[data-stage-next]');
    if (prevBtn) { prevBtn.addEventListener('click', function () { setSlide(curSlide - 1, true); }); }
    if (nextBtn) { nextBtn.addEventListener('click', function () { setSlide(curSlide + 1, true); }); }
    if (stage && slides.length > 1) {
      var touchX = 0;
      stage.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 40) { setSlide(curSlide + (dx < 0 ? 1 : -1), true); }
      }, { passive: true });
    }
    if (slides.length) { setSlide(0, false); }

    // Add to cart
    function showError(msg) {
      if (errorEl) { errorEl.textContent = msg; errorEl.classList.remove('hide'); }
    }

    function resolveVariant() {
      var vid = idInput ? idInput.value : null;
      if (!vid) return null;
      return variants.find(function (v) { return String(v.id) === String(vid); }) || null;
    }

    function submitAdd() {
      var variant = resolveVariant();
      if (!variant || !variant.available) {
        showError('Please select an available option.');
        return;
      }
      if (addBtn) addBtn.classList.add('is-loading');
      if (errorEl) errorEl.classList.add('hide');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: idInput.value, quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1, properties: { _splinter: '1' } })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) {
            if (addBtn) addBtn.classList.remove('is-loading');
            showError(result.data && result.data.description ? result.data.description : 'Could not add to cart.');
            return;
          }
          var ct = cartType();
          if (ct === 'drawer' || ct === 'sticky') {
            if (addBtn) addBtn.classList.remove('is-loading');
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: { product: result.data, addToCartBtn: addBtn }
            }));
          } else {
            window.location.href = cartUrl;
          }
        })
        .catch(function () {
          if (addBtn) addBtn.classList.remove('is-loading');
          showError('Network error. Please try again.');
        });
    }

    function ajaxCart() {
      var ct = cartType();
      return ct === 'drawer' || ct === 'sticky';
    }

    // For a "page" cart, let the form POST natively to /cart/add (Shopify redirects to /cart):
    // bulletproof, no dependency on JS timing. Only intercept for drawer/sticky carts.
    if (form) form.addEventListener('submit', function (e) {
      if (ajaxCart()) { e.preventDefault(); submitAdd(); return; }
      var variant = resolveVariant();
      if (!variant || !variant.available) { e.preventDefault(); showError('Please select an available option.'); }
    });
    if (stickyBtn) stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (ajaxCart()) { submitAdd(); return; }
      var variant = resolveVariant();
      if (!variant || !variant.available) { showError('Please select an available option.'); return; }
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    });

    // Sticky bar visibility (mobile)
    var sticky = root.querySelector('[data-splinter-sticky]');
    if (sticky && form && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
          sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, { rootMargin: '0px 0px -80px 0px' });
      observer.observe(form);
    }

    refreshSoldOut();
    updateUI();
  }

  function initAll(context) {
    (context || document).querySelectorAll('[data-splinter-product]').forEach(initSplinter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
